import { render, staticRenderFns } from "./password-verify.vue?vue&type=template&id=56bcc634"
import script from "./password-verify.vue?vue&type=script&lang=js"
export * from "./password-verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bcc634')) {
      api.createRecord('56bcc634', component.options)
    } else {
      api.reload('56bcc634', component.options)
    }
    module.hot.accept("./password-verify.vue?vue&type=template&id=56bcc634", function () {
      api.rerender('56bcc634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/login/components/reset-password/password-verify.vue"
export default component.exports